import { DHLRatesResponse, Product } from '../types/Courier/DHL/DHLRatesResponse'
import {IPickUpDetails} from '../types/Courier/DHL/DHLPickUpDetails'

export const formatPlannedPickupDateAndTime = (plannedPickupDateAndTime: Date) => {
    // plannedPickupDateAndTime is currently a JS date e.g. Mon Jul 19 2021 09:00:00 GMT+1000 (Australian Eastern Standard Time)
    // DHL requires the time to be returned as yyyy-mm-ddThh:mm GMT+hh:mm
    // we need to  take into account 12hr vs 24hr clock settings in browsers and timezone

    const date = plannedPickupDateAndTime.toLocaleDateString("en-GB").split('/').reverse().join('-')
    const time = plannedPickupDateAndTime.toLocaleTimeString("en-GB") // passing "en-GB" ensures that the time is in 24h format as DHL requires
    const GMTZone = plannedPickupDateAndTime.toString().split(' ')[5].split('')
    GMTZone.splice(-2, 0, ':')

    return `${date}T${time} ${GMTZone.join('')}`
}
    
const getProductType = (data: DHLRatesResponse):Product => {
    const services = data?.products?.filter(
        (product: { productName: string }) =>
            product.productName === 'ECONOMY SELECT NONDOC' ||
            product.productName === 'EXPRESS WORLDWIDE NONDOC' ||
            product.productName === 'EXPRESS DOMESTIC' ||
            product.productName === 'ECONOMY SELECT EU' ||
            product.productName === 'EXPRESS WORLDWIDE EU' ||
            product.productName === 'ECONOMY SELECT' ||
            product.productName === 'EXPRESS WORLDWIDE'
    ) ?? []

    // choose economic rate when there are more than one rate available
    return services.length > 1 ? services.filter(
        (obj) => obj.productName === 'ECONOMY SELECT NONDOC' || obj.productName === 'ECONOMY SELECT EU' || obj.productName === 'ECONOMY SELECT'
    )[0] : services[0]
}

export const getPlannedPickupDateAndTime = (data: DHLRatesResponse, currentDateTime: any): IPickUpDetails => {
    const { pickupCapabilities: { pickupEarliest, pickupLatest, localCutoffDateAndTime }, productCode } = getProductType(data)
    const localCutoffDateAndTimeFormatted: any = new Date(localCutoffDateAndTime)

    let plannedPickupDateAndTime

    const missedCutOff: boolean = currentDateTime - localCutoffDateAndTimeFormatted > 0

    if (missedCutOff) {
        // if missed cut off, pickUpAvailability request made again with new date (recursive fn)
        // (e.g. currentDate: 2021/02/03 17:34, cutOff: 2021/02/03 17:00)
        plannedPickupDateAndTime = currentDateTime
    } else {
        // if currentDate is NOT equal to localCutoffDateAndTime (localCutOff 1 day ahead due to recursive fn)
        // (e.g. currentDate: 2021/02/03 17:34, cutOff: 2021/02/04 17:00)
        // Use localCutoffDateAndTime DATE with pickUpEarliest TIME
        if (currentDateTime.getDate() != localCutoffDateAndTimeFormatted.getDate()) {
            plannedPickupDateAndTime = new Date(
                localCutoffDateAndTimeFormatted.getFullYear(),
                localCutoffDateAndTimeFormatted.getMonth(),
                localCutoffDateAndTimeFormatted.getDate(),
                Number(pickupEarliest.split(':')[0]),
                Number(pickupEarliest.split(':')[1])
            )
        }
        // if currentDate IS equal to localCutoffDateAndTime
        else {
            // if currentTime is EARLIER than pickupEarliest, use pickUpEarliest time
            // (e.g. currentDate: 2021/02/03 00:15, pickupEarliest 2021/02/03 09:00)
            if (currentDateTime.getHours() < pickupEarliest.split(':')[0]) {
                plannedPickupDateAndTime = new Date(
                    localCutoffDateAndTimeFormatted.getFullYear(),
                    localCutoffDateAndTimeFormatted.getMonth(),
                    localCutoffDateAndTimeFormatted.getDate(),
                    Number(pickupEarliest.split(':')[0]),
                    Number(pickupEarliest.split(':')[1])
                )
                // add 15min grace, eg. availability request made 08:59am submitting pickup request is done after 09:00am,
                // request would fail as plannedPickupDateAndTime would be in the past
                plannedPickupDateAndTime.setMinutes(plannedPickupDateAndTime.getMinutes() + 15)
            } else {
                // if currentTime is LATER than pickupEarliest, but EARLIER than localCutOffDateAndTime
                // use currentDateTime
                // (e.g. currentDate: 2021/02/03 12:00, cutOff 2021/02/03 17:00)
                plannedPickupDateAndTime = currentDateTime
            }
        }
    }

    return {
        missedCutOff,
        plannedPickupDateAndTime,
        pickupLatest,
        productCode
    }
}
